import { render, staticRenderFns } from "./retailerPaymentBulkUpload.vue?vue&type=template&id=0484bf4f&"
import script from "./retailerPaymentBulkUpload.vue?vue&type=script&lang=js&"
export * from "./retailerPaymentBulkUpload.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports